import { formatter } from './../constantes/formatter';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiplicarValor'
})
export class MultiplicarValorPipe implements PipeTransform {

  transform(primeiroFator: number, segundoFator: number): string {
    if (primeiroFator) {
      return formatter.format(primeiroFator * segundoFator);
    } else {
      return '0'
    }
  }

}
